import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AgGridModule } from 'ag-grid-angular';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TranslateModule } from '@ngx-translate/core';

import { UIRouterModule } from '@uirouter/angular';

import { CssRulesAngularModule } from 'rev-shared/ui/css/Css.AngularModule';
import { HighlightModule } from 'rev-shared/pipes/highlight/Highlight.Module';
import { SearchInputModule } from 'rev-shared/ui/searchInputAngular/SearchInput.Module';
import { SidebarLayoutModule } from 'rev-shared/ui/sidebarLayout/SidebarLayout.Module';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { VbBtnWhiteDirective } from 'rev-shared/ui/buttons/VbBtnWhite.Directive';
import { VbDropdownMenuModule } from 'rev-shared/ui/dropdown-menu/VbDropdownMenu.Module';
import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';
import { VbToggleButtonComponent } from 'rev-shared/ui/buttons/VbToggleButton.Component';
import { VbUiCheckboxComponent } from 'rev-shared/ui/checkbox/VbUiCheckbox.Component';
import { VbUiCheckboxGroupComponent } from 'rev-shared/ui/checkbox/VbUiCheckboxGroup.Component';

import { VbUiDataGridComponent } from './VbUiDataGrid.Component';
import { VbUiInfiniteScrollGridComponent } from './infiniteScroll/VbUiInfiniteScrollGrid.Component';
import { VbUiTreeGridComponent } from './tree/VbUiTreeGrid.Component';

import { ActionIconsRendererComponent } from './cellRenderers/ActionIconCellRenderer.Component';
import { ActionMenuButtonCellRendererComponent } from './cellRenderers/ActionMenuButtonCellRenderer.Component';
import { ButtonGroupCellRendererComponent } from './cellRenderers/ButtonGroupCellRenderer.Component';
import { CheckboxCellRendererComponent } from './cellRenderers/CheckboxCellRenderer.Component';
import { HeaderSelectAllCheckboxRendererComponent } from './cellRenderers/HeaderSelectAllCheckboxRenderer.Component';
import { HighlightCellRendererComponent } from './cellRenderers/HighlightCellRenderer.Component';
import { IconCellRendererComponent } from './cellRenderers/IconCellRenderer.Component';
import { LinkCellRendererComponent } from './cellRenderers/LinkCellRenderer.Component';
import { ProfilePictureCellRendererComponent } from './cellRenderers/ProfilePictureCellRenderer.Component';
import { TogglesCellRendererComponent } from './cellRenderers/TogglesCellRenderer.Component';
import { VbTextColumnFilterComponent } from './columnFilters/VbTextColumnFilter.Component';
import { VbUiDataGridColumnPicker } from './columnPicker/VbUiDataGridColumnPicker.Component';
import { VbUiDataGridColumnPickerGroup } from './columnPicker/VbUiDataGridColumnPickerGroup.Component';
import { VbUiDataGridTooltipComponent } from './tooltip/VbUiDataGridTooltip.Component';
import { VbUiGridCellKeyboardHandlerDirective } from './keyboard/VbUiGridCellKeyboardHandler.Directive';

const gridRendererComponents = [
	ActionIconsRendererComponent,
	ActionMenuButtonCellRendererComponent,
	ButtonGroupCellRendererComponent,
	CheckboxCellRendererComponent,
	HeaderSelectAllCheckboxRendererComponent,
	HighlightCellRendererComponent,
	IconCellRendererComponent,
	LinkCellRendererComponent,
	ProfilePictureCellRendererComponent,
	TogglesCellRendererComponent,
	VbUiDataGridTooltipComponent,
];

const components = [
	...gridRendererComponents,
	VbUiDataGridColumnPickerGroup,
	VbUiDataGridColumnPicker,
	VbUiDataGridComponent,
	VbUiInfiniteScrollGridComponent,
	VbUiTreeGridComponent,
	VbUiGridCellKeyboardHandlerDirective
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		AgGridModule,
		BsDropdownModule,
		CommonModule,
		CssRulesAngularModule,
		FormsModule,
		HighlightModule,
		SearchInputModule,
		SidebarLayoutModule,
		SpinnerAngularModule,
		TranslateModule,
		UIRouterModule,
		VbBtnWhiteDirective,
		VbDropdownMenuModule,
		VbProfilePictureModule,
		VbTextColumnFilterComponent,
		VbToggleButtonComponent,
		VbUiCheckboxComponent,
		VbUiCheckboxGroupComponent
	]
})
export class DataGridModule { }
